import { render } from "./404.vue?vue&type=template&id=c1b79d12"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
script.render = render

export default script